module.exports = __webpack_public_path__ + "static/img/2.dcaf12c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/2.png
// module id = GBET
// module chunks = 0